module.exports = __webpack_public_path__ + "static/img/nothing2.88fd87d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/nothing2.png
// module id = uQdl
// module chunks = 1